import {
  autoUpdate,
  flip,
  offset,
  shift,
  useFloating,
} from '@floating-ui/vue'
import { onClickOutside } from '@vueuse/core'

import type { CSSProperties, Ref } from 'vue'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

import { faEllipsisVertical, faEye } from '@fortawesome/pro-regular-svg-icons'

interface ChangelogItemActionsOptions {
  onView: () => void
}

interface ChangelogItemActionsReturn {
  isOpen: Ref<boolean>
  containerRef: Ref<HTMLElement | null>
  floatingRef: Ref<HTMLElement | null>
  floatingStyles: Ref<CSSProperties>
  triggerIcon: IconDefinition
  viewIcon: IconDefinition
  toggle: () => void
  handleView: () => void
}

export const useChangelogItemActions = ({ onView }: ChangelogItemActionsOptions): ChangelogItemActionsReturn => {
  const isOpen = ref(false)
  const containerRef = ref<HTMLElement | null>(null)
  const floatingRef = ref<HTMLElement | null>(null)

  const { floatingStyles } = useFloating(containerRef, floatingRef, {
    placement: 'bottom-end',
    strategy: 'fixed',
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(4),
      flip(),
      shift({ padding: 8 }),
    ],
  })

  const toggle = (): void => {
    isOpen.value = !isOpen.value
  }

  const handleView = (): void => {
    isOpen.value = false
    onView()
  }

  onClickOutside(containerRef, () => {
    isOpen.value = false
  })

  return {
    isOpen,
    containerRef,
    floatingRef,
    floatingStyles,
    triggerIcon: faEllipsisVertical,
    viewIcon: faEye,
    toggle,
    handleView,
  }
}
